module.exports = __webpack_public_path__ + "static/media/Overview.a0dfd2fd.svg";